import { Link } from "react-router-dom";
import { Organization } from "../../hooks/api-new";
import useUser from "../../hooks/user";
import { useCurrentPlan } from "../context/organization/organization";
import { useMemo } from "react";

const UpgradeNow = (props: {
  organization: Organization;
  goToCalendly?: boolean;
  className?: string;
}) => {
  const [user] = useUser();
  const currentPlan = useCurrentPlan(props.organization);

  const message = useMemo(() => {
    if (currentPlan === "starter") {
      return (
        <h3 className={props.className}>
          <span
            style={{
              color:
                props.organization.translation_seconds_remaining > 0
                  ? "var(--langfinity-green)"
                  : "var(--langfinity-red)",
            }}
          >
            {Math.round(props.organization.translation_seconds_remaining / 60)}
          </span>{" "}
          of 20 min remaining{" "}
          <Link
            style={{ color: "white", textDecoration: "underline" }}
            target="_blank"
            to={
              !props.goToCalendly
                ? "/billing"
                : "https://calendly.com/snow-huo-byrdhouse/30min"
            }
          >
            Upgrade now
          </Link>
        </h3>
      );
    } else {
      return (
        <h3 className={props.className}>
          <span
            style={{
              color:
                props.organization.translation_seconds_remaining > 0
                  ? "var(--langfinity-green)"
                  : "var(--langfinity-red)",
            }}
          >
            {Math.round(props.organization.translation_seconds_remaining / 60)}
          </span>{" "}
          min remaining{" "}
          <Link
            style={{ color: "white", textDecoration: "underline" }}
            target="_blank"
            to={
              !props.goToCalendly
                ? "/billing"
                : "https://calendly.com/snow-huo-byrdhouse/30min"
            }
          >
            Get more
          </Link>
        </h3>
      );
    }
  }, [
    currentPlan,
    props.goToCalendly,
    props.className,
    props.organization.translation_seconds_remaining,
  ]);

  // Show no mins remaining to all users
  if (props.organization.translation_seconds_remaining <= 0) {
    return message;
  }

  if (!user.auth) {
    return;
  }

  if (
    props.organization.translation_seconds_remaining <= 20 * 60 &&
    currentPlan === "starter"
  ) {
    return message;
  }

  if (
    props.organization.translation_seconds_remaining <= 10 * 60 &&
    currentPlan !== "starter"
  ) {
    return message;
  }
};

export default UpgradeNow;
